import { ReactNode } from "react";
import { makeStyles, Text, typographyStyles, Divider, Button } from "@fluentui/react-components";
import { ArrowLeft12Filled } from "@fluentui/react-icons";

const useStyles = makeStyles({
    root: {
        minHeight: "100vh",
        padding: "1rem",
    },
    title: typographyStyles.title2,
    title3: typographyStyles.subtitle1,
    loading_root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
    },
    column: {
        display: "flex",
        flexDirection: "column",
    },
    header_row: {
        display: "flex",
        gap: "1rem",
        alignItems: "center",
    },
    no_margin: {
        marginBottom: "0px",
        marginTop: "0px",
    },
    content: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
    divider: {
        margin: "1rem 0rem",
    },
});

interface BasicLayoutProps {
    title: string;
    children: ReactNode;
    onBack?: () => void;
}

export const BasicLayout = ({ title, children, onBack }: BasicLayoutProps) => {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <div className={styles.column}>
                <div className={styles.header_row}>
                    {onBack && <Button icon={<ArrowLeft12Filled />} onClick={onBack} />}
                    <Text as="h1" className={`${styles.title} ${styles.no_margin}`}>
                        {title}
                    </Text>
                </div>
                <Divider className={styles.divider} appearance="brand" />
            </div>
            <div className={styles.content}>{children}</div>
        </div>
    );
};